module.exports = __webpack_public_path__ + "media/images/metronic/portlet-remove-icon-ebc01e91cc50b33253ee5c0730592ec5.png";